import {getPlantElectric, pageInfo,savePlantElectric, queryPlantElectricDetail} from './../api';
import {fenceType} from '../../../../api'
const plant = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    supplierTypeObj: [],
    goodsCategoryObj: [],
    plantObj: [],
    plantElectricObj: [],
    savePlantElectricObj:null,
    plantElectricDetailObj: null,
    fenceObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    GET_PLANT_ELECTRIC(state, data) {
      state.plantElectricObj = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    SAVE_PLANT_ELECTRIC(state, data){
      state.savePlantElectricObj = data;
    },
    QUERY_PLANT_ELECTRIC_DETAIL(state, data){
      state.plantElectricDetailObj = data;
    },
    FENCE_TYPE(state, data){
      state.fenceObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async getPlantElectric({commit}, obj) {
      let resp = await getPlantElectric(obj);
      commit('GET_PLANT_ELECTRIC', resp);
    },
    async savePlantElectric({commit}, obj) {
      let result = await savePlantElectric(obj);
      commit('SAVE_PLANT_ELECTRIC', result);
    },
    async queryPlantElectricDetail({commit}, obj) {
      let result = await queryPlantElectricDetail(obj);
      commit('QUERY_PLANT_ELECTRIC_DETAIL', result);
    },
    async fenceType({commit}, obj) {
      let result = await fenceType(obj);
      commit('FENCE_TYPE', result);
    }
  }
}
export default plant



// WEBPACK FOOTER //
// ./src/page/md/plant/store/plant.store.js